import { CSSProperties } from 'react';
import { StylesConfig } from 'react-select';

export const customStyles: StylesConfig<any, true> = {
  control: (provided, state) => ({
    ...provided,
    minHeight: '44px',
    borderColor: state.isFocused ? 'var(--primary-blue)' : 'var(--mid-grey-2)',
    borderWidth: '0.5px',
    borderRadius: '8px',
    outline: 'none',
    boxShadow: 'none',
    '&:hover': {
      borderColor: state.isFocused
        ? 'var(--primary-blue)'
        : 'var(--mid-grey-2)',
    },
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  input: (provided) => ({
    ...provided,
    outline: 'none',
  }),
};

export const multiSelectStyles: StylesConfig<any, true> = {
  control: (provided, state) => ({
    ...provided,
    height: '5.5rem',
    minHeight: '44px',
    borderColor: state.isFocused ? 'var(--primary-blue)' : 'var(--mid-grey-2)',
    borderWidth: '0.5px',
    borderRadius: '8px',
    outline: 'none',
    overflow: 'hidden',
    boxShadow: 'none',
    '&:hover': {
      borderColor: state.isFocused
        ? 'var(--primary-blue)'
        : 'var(--mid-grey-2)',
    },
  }),
  valueContainer: (provided) => {
    return {
      ...provided,
      alignItems: 'flex-start',
      padding: '0.5rem 3rem 0.5rem 0.5rem',
      overflow: 'auto',
      height: '100%',
      width: '100%',
    };
  },
  multiValue: (provided, data) => {
    return {
      ...provided,
      backgroundColor: data.data.value.includes('Multiple')
        ? 'rgba(167, 63, 142, 0.1)'
        : 'rgba(0, 116, 204, 0.1)',
      borderRadius: '0.5rem',
      padding: '0.5rem',
    };
  },
  multiValueLabel: (provided, data) => {
    return {
      ...provided,
      color: data.data.value.includes('Multiple') ? '#a73f8e' : '#0074cc',
      fontSize: '14px',
    };
  },
  multiValueRemove: (provided, data) => {
    return {
      ...provided,
      color: data.data.value.includes('Multiple') ? '#a73f8e' : '#0074cc',
      cursor: 'pointer',
      padding: '0 0 0 8px',
      '&:hover': {
        backgroundColor: 'transparent',
        color: data.data.value.includes('Multiple') ? '#a73f8e' : '#0074cc',
      },
      svg: {
        stroke: '#e5f1fa',
        strokeWidth: '1px',
        width: '20px',
        height: '20px',
      },
    };
  },
  placeholder: (provided) => {
    return {
      ...provided,
      top: '1rem',
    };
  },
  indicatorSeparator: () => ({
    display: 'none',
  }),
  input: (provided) => ({
    ...provided,
    outline: 'none',
    height: 'auto',
    paddingTop: '0.66rem',
  }),
};
